export enum Language {
  en = 'en',
  fr = 'fr',
}

export enum LogLevel {
  info,
  all,
  error,
  off,
  warn,
  debug,
}

export enum CustomEvents {
  backButtonClicked = 'nfbplayer:backbuttonclicked',
  nextEpisodeClicked = 'nfbplayer:nextepisodeclicked',
  sourceHasExpired = 'nfbplayer:sourcehasexpired'
}

export type NFBPlayerOptions = {
  source: string;
  dvSource?: string;
  // inherit from videoJS
  poster?: string;
  controls?: boolean;
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  preload?: "metadata";
  language?: Language;
  inactivityTimeout?: number;
  playbackRates?: number[];
  html5?: {
    vhs?: {
      handlePartialData?: boolean
      limitRenditionByPlayerDimensions?: boolean
      enableLowInitialPlaylis?: boolean
      overrideNative?: boolean
      withCredentials?: boolean
    }
  };
  // custom
  theme?: {
    name?: string | "default";
    accentColor?: string;
  };
  offset?: {
    start?: number; // in seconds
    end?: number; // in seconds
  };
  restartFromBeginning?: boolean;
  seekButtons?: {
    forward?: boolean;
    backward?: boolean;
    seekDuration?: number; // in seconds
  };
  hotKeys?: {
    autofocus?: boolean;
  };
  persistOptions?: {
    persistCC?: boolean;
    persistVolume?: boolean;
  };
  ratings?: {
    message?: string;
  };
  chromecast?: {
    addButtonToControlBar?: boolean;
  };
  airPlay?: {
    addButtonToControlBar?: boolean;
  };
  vr?: any | false; // options here : https://github.com/videojs/videojs-vr#options
  trickplay?: boolean;
  overlay?: {
    title?: string;
    description: string;
    url: string;
    embed: {
      html: string;
      options: {
        width: number;
        height: number;
      };
    };
    language?: Language;
  };
  triggerWarnings?: {
    items: [
      {
        title: string;
        description: string;
        rank: number;
        displayTime: number;
      }
    ];
  };
  disableResolutions?: number[];
  ready?: Function;
  logLevel?: LogLevel; // https://docs.videojs.com/tutorial-debugging.html
  // When dynamicCssImports = false, all import() statements for sass files
  // in plugins will be ignored. This includes:
  // - import('../sass/plugins/overlay.sass') in NFBOverlay
  // - import('../sass/plugins/ratings.sass') in NFBRatings
  // - import(`../sass/themes/${themeName}/index.sass`) in NFBTheme
  // - import('../sass/plugins/trigger-warnings.sass') in NFBWarnings
  // These files need to be imported manually.
  // Added to manage case when player is in the shadow DOM.
  // import() with webpack import files in the light DOM scope.
  dynamicCssImports?: boolean
};
